module.exports = {
  // 模块名称
  elePatroReport: {
    // 按钮类
    button: {
      export: '导出',
      reset: '重置',
      query: '查询',
    },
    // 文字标签类
    label: {
      taskName: '计划名称',
      recomTime: '计划巡更时间',
      realTime: '实际巡更时间',
      realStartTime: '实际开始时间',
      realEndTime: '实际结束时间',
      reportPerson: '保卫人员',
      clockProgress: '打卡进度',
      taskStatus: '任务状态',
      operation: '操作',
      toPatrol: '待巡逻',
      patrolling: '巡逻中',
      completed: '已完成',
      timeout: '已超时',
      personInCharge: '责任人',
      detailTaskStatus: '状态',
      hasClock: '已打卡',
      unClock: '未打卡'
    },
    // 提示类
    placeholder: {
      taskName: '请输入计划名称',   
      startTime: '开始时间',
      endTime: '结束时间',
      taskStatus: '全部任务'
    },
    // 消息类
    message: {
      exportFile: '暂无数据可以导出',
      exportFileConfirm1: '未输入时间，默认导出最近7天数据',
      prompt: '提示',
      confirmText: '确定',
      cancelText: '取消',
      fileName: '电子巡更记录',
      exportFileConfirm2: '导出数据时间跨度不可超过30天',
    },
    // 标题类
    title: {
      to: '至',
      reportDetail: '报告详情',
    }
  }
}